<template>
  <Modal
    v-model="collectMdl"
    id="ModalUser"
    width="794"
    :mask-closable="false"
    :closable="false"
    class-name="vertical-center-modal fav"
  >
    <div slot="header" style="padding-left:32px;" class="fav-header">
      {{title}}
      <i class="iconfont icon-pop-close" @click="close"></i>
    </div>
    <div class="userUpload">
      <my-upload
        style="display:inline-block;float:left;"
        v-if="!collectionId && collectMdl"
        :type="3"
        :format="['jpg','jpeg','png']"
        @success="handleSuccess"
        :multiple="false"
        @uploadError="handleUploadError"
        @formatError="handleFormatError"
        @progress="handleProgress"
      >
        <div class="left" :class="error.imgNull ? 'leftRed' : ''" slot="style">
          <div v-if="!imgData">
            <button>添加图片</button>
            <p class="title">拖拽图片到该区域，完成上传</p>
            <p class="desc">支持单张10M以内图片上传</p>
            <Progress v-if="progress > 0" :percent="progress" style="margin-top:10px;"></Progress>
          </div>
          <div class="bottomDesc">上传图片通过审核后发布至{{type === 1 ?'灵感源' : '产品库'}}</div>
          <div class="bottomDesc bottomDescRed" v-if="error.imgNull">请添加图片</div>
          <div class="imgCon" v-if="imgData">
            <img :src="imgBaseUrl + imgData.key" alt>
          </div>
        </div>
      </my-upload>

      <div class="left" v-if="collectionId" :class="error.imgNull ? 'leftRed' : ''" slot="style">
        <div class="imgCon" v-if="imgData">
          <img :src="imgBaseUrl + imgData.key" alt>
        </div>
      </div>

      <div class="right">
        <div class="right-product" v-if="type === 1">
          <div class="item">
            <p class="text">图片描述：</p>
            <p class="input">
              <textarea placeholder="请输入图片描述" maxlength="500" v-model="inspiration.imgDsc"></textarea>
            </p>
          </div>
          <div class="item">
            <p class="text">图片标签：</p>
            <p class="input">
              <input
                @keyup.enter="newTarget"
                type="text"
                maxlength="8"
                placeholder="输入文字，按回车以生成标签(最多八个字符)"
                v-model="imgTarget"
              >
            </p>
            <div class="target">
              <Tag
                closable
                :fade="false"
                @on-close="closeTarget(index)"
                v-for="(item,index) in inspiration.imgTargetData"
                :key="index"
                color="yellow"
              >{{item}}</Tag>
            </div>
          </div>
        </div>
        <div class="right-product" v-if="type === 2">
          <div class="item">
            <p class="text">
              <span>*</span>名称：
              <span v-if="error.imgName">图片名称不能为空，且少于20个字符</span>
            </p>
            <p class="input">
              <input maxlength="20" type="text" v-model="prudtctData.name">
            </p>
          </div>
          <div class="item">
            <p class="text">
              <span>*</span>规格：
              <span v-if="error.size">请填写单品规格</span>
            </p>
            <p class="input">
              <input type="text" maxlength="100" v-model="prudtctData.size">
            </p>
          </div>
          <div class="item">
            <p class="text">
              <span>*</span>材质：
              <span v-if="error.material">请填写单品材质</span>
            </p>
            <p class="input">
              <input type="text" maxlength="20" v-model="prudtctData.material">
            </p>
          </div>
        </div>
      </div>
      <dir class="userUploadBottom">
        <button @click="submit">完成</button>
      </dir>
    </div>
    <collector ref="collector"></collector>
  </Modal>
</template>

<script>
import api from "../../api";
import myUpload from "./myUpload.vue";
import collector from "./collector.vue";

export default {
  data() {
    return {
      collectMdl: false,
      title: "",
      imgData: null,
      progress: 0,
      imgBaseUrl: api.common.imgBaseUrl,
      type: 1,
      imgTarget: "",
      collectionId: "",
      error: {
        imgNull: false,
        imgName: false,
        size: false,
        material: false
      },
      prudtctData: {
        name: "",
        size: "常规",
        material: "常规"
      },
      inspiration: {
        imgDsc: "",
        imgTargetData: []
      }
    };
  },
  methods: {
    newTarget() {
      if (!this.imgTarget) {
        this.$Message.warning("请输入标签名称");
        return;
      }
      if (this.inspiration.imgTargetData.length > 7) {
        this.$Message.warning("标签个数最多不能超过8个");
        return;
      }
      if (this.inspiration.imgTargetData.indexOf(this.imgTarget) > -1) {
        this.$Message.warning("标签不能重复");
        return;
      }
      this.inspiration.imgTargetData.push(this.imgTarget);
      this.imgTarget = "";
    },
    closeTarget(index) {
      if (index > -1) {
        this.inspiration.imgTargetData.splice(index, 1);
      }
    },
    handleUploadError() {
      this.$Message.error("上传失败,请重新上传");
      this.progress = 0;
    },
    handleFormatError() {
      this.$Message.error("上传失败,请重新上传");
      this.progress = 0;
    },
    handleProgress(progress) {
      this.progress = progress;
      this.imgData = null;
    },
    handleSuccess(file) {
      if (!file) {
        this.$Message.error("上传失败,请重新上传");
        this.progress = 0;
        return;
      }
      this.imgData = file.data[0];
      this.inspiration.imgDsc = this.imgData.name;
      this.prudtctData.name = this.imgData.name;
      this.error.imgNull = false;
      this.progress = 0;
    },
    close() {
      this.collectMdl = false;
    },
    open(type, params = "", collectionId = "") {
      this.type = type;
      this.collectionId = collectionId;
      this.title = type === 1 ? "上传灵感源" : "上传产品";
      if (params) {
        type === 2 ? (this.prudtctData.name = params.name) : "";
        type === 2 ? (this.prudtctData.size = params.size) : "";
        type === 2 ? (this.prudtctData.material = params.material) : "";
        type === 2 ? (this.imgData = params.coverFile) : "";
        type === 1 ? (this.imgData = params.inspirationFile) : "";
        type === 1 ? (this.inspiration.imgDsc = params.describe) : "";
        type === 1
          ? (this.inspiration.imgTargetData = params.labels || [])
          : "";
      }
      this.error = {
        imgNull: false,
        imgName: false,
        size: false,
        material: false
      };
      this.collectMdl = true;
    },
    submit() {
      if (!this.imgData) {
        this.error.imgNull = true;
        return;
      }
      if (
        (this.type === 2 && !this.prudtctData.name) ||
        (this.type === 2 && this.prudtctData.name.length > 19)
      ) {
        this.error.imgName = true;
        return;
      }
      if (this.type === 2 && !this.prudtctData.size) {
        this.error.size = true;
        return;
      }
      if (this.type === 2 && !this.prudtctData.material) {
        this.error.material = true;
        return;
      }
      if (!this.collectionId) {
        if (this.type === 2) {
          let data = {
            name: this.prudtctData.name,
            size: this.prudtctData.size,
            material: this.prudtctData.material,
            coverFile: this.imgData
          };
          this.$refs.collector.open(data, "uploadProduct");
          this.collectMdl = false;
        }
        if (this.type === 1) {
          let data = {
            inspiration: {
              describe: this.inspiration.imgDsc,
              labels: this.inspiration.imgTargetData,
              inspirationFile: this.imgData
            }
          };
          this.$refs.collector.open(data, "uploadInspiration");
          this.collectMdl = false;
        }
      } else {
        let params = {
          describe: this.inspiration.imgDsc,
          material: this.prudtctData.material,
          name: this.prudtctData.name,
          size: this.prudtctData.size,
          labels: this.inspiration.imgTargetData,
          type: this.type === 1 ? 3 : 1
        };
        api.inspirations
          .put_collection_detail(this.collectionId, params)
          .then(res => {
            this.$Message.success("修改成功");
            this.$emit("upload");
            this.collectMdl = false;
          });
      }
    }
  },
  watch: {
    "prudtctData.name": function() {
      if (this.prudtctData.name) {
        this.error.imgName = false;
      }
    },
    "prudtctData.size": function() {
      if (this.prudtctData.size) {
        this.error.size = false;
      }
    },
    "prudtctData.material": function() {
      if (this.prudtctData.material) {
        this.error.material = false;
      }
    },
    collectMdl: function() {
      if (!this.collectMdl) {
        this.prudtctData.name = "";
        this.prudtctData.size = "常规";
        this.prudtctData.material = "常规";
        this.inspiration.imgDsc = "";
        this.inspiration.imgTargetData = [];
        this.imgTarget = "";
        this.imgData = null;
      }
    }
  },
  components: {
    myUpload,
    collector
  },
  created() {}
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.fav {
  .fav-content-right {
    overflow: auto;
  }
  &-header {
    font-size: 20px;
    color: #353838;
    letter-spacing: 4px;
    text-align: left;
    position: relative;
    i {
      position: absolute;
      top: -10px;
      right: 20px;
      cursor: pointer;
      &:after {
        content: "";
        position: absolute;
        top: -10px;
        right: -10px;
        bottom: -10px;
        left: -10px;
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .userUpload {
    height: 550px;
    padding: 20px 50px;
    .left {
      width: 273px;
      height: 360px;
      float: left;
      cursor: pointer;
      border: 1px dashed #bfbfbf;
      text-align: center;
      position: relative;
      .imgCon {
        width: 100%;
        height: 100%;
        line-height: 360px;
        > img {
          max-width: 100%;
          max-height: 100%;
          vertical-align: middle;
          margin-top: -5px;
        }
      }

      button {
        background: #efefef;
        border-radius: 3px;
        font-size: 16px;
        color: #373737;
        padding: 1px 12px;
        margin-top: 135px;
      }
      p {
        height: 25px;
      }
      p.title {
        text-align: center;
        font-size: 12px;
        color: #373737;
        margin-top: 15px;
      }
      p.desc {
        font-size: 11px;
        color: #bfbfbf;
      }
      .bottomDesc {
        font-size: 10px;
        color: #bfbfbf;
        position: absolute;
        bottom: -30px;
        width: 300px;
        left: -14px;
      }
      .bottomDescRed {
        bottom: -50px;
        color: #e14b5d;
      }
    }
    .leftRed {
      border: 1px dashed #e14b5d;
    }
    .right {
      float: left;
      margin-left: 23px;
      width: 340px;
      text-align: left;
      .item {
        margin-bottom: 20px;
        .text {
          font-size: 14px;
          color: #373737;
          margin-bottom: 10px;
          > span {
            color: #e14b5d;
          }
        }
        .input {
          input {
            width: 100%;
            height: 42px;
            border: none;
            background: #efefef;
            padding: 0 10px;
          }
          textarea {
            width: 100%;
            height: 200px;
            border: none;
            background: #efefef;
            padding: 10px;
          }
        }
        .target {
          margin-top: 10px;
        }
      }
    }
    .userUploadBottom {
      width: 100%;
      text-align: center;
      float: left;
      position: absolute;
      bottom: 30px;
      left: 0;
      &:hover {
        opacity: 0.8;
      }
      button {
        background: #f5a623;
        width: 140px;
        height: 45px;
        font-size: 12px;
        color: #ffffff;
      }
    }
  }
}
</style>

